import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, ButtonResponsiveWrapper, HASIcon, useResponsive } from '@common-fe/common-fe';

import { Banner } from '@/modules/core/components/Dashboard/components/BannersList/Banner';
import { useSwitchPopupStore } from '@/modules/user/components/UserDrodpdown/stores';

import { BannerActionCompleted, BannerStorageKey, YES_KEY } from '../bannersList.constants';
import useDismissBanner from '../hooks/useDismissBanner';

const ImportantChangesBanner = () => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();
  const { setIsPopupVisible } = useSwitchPopupStore();
  const { handleDismissBanner } = useDismissBanner();

  const handleOpenPopup = useCallback(() => {
    setIsPopupVisible(true);
    localStorage.setItem(BannerActionCompleted.ImportantChangesBannerAction, YES_KEY);
    window.scrollTo(0, 0);
  }, [setIsPopupVisible]);

  const handleDismiss = useCallback(() => {
    handleDismissBanner(BannerStorageKey.ImportantChangesBanner);
  }, [handleDismissBanner]);

  const isDismissButtonAvailable =
    localStorage.getItem(BannerActionCompleted.ImportantChangesBannerAction) === YES_KEY;

  return (
    <Banner
      title={t('Important Changes to Your HSA')}
      description={t(
        "We noticed you recently separated from your employer. Don't worry! You still have access to your old employer sponsored account."
      )}
      icon={<HASIcon />}
      testId="important-changes"
    >
      <div>
        <ButtonResponsiveWrapper isReversedMode margin={{ top: 'spacing24' }}>
          <AppButton fill={isMobile} testId="show-me-how" onClick={handleOpenPopup} width="180px">
            {t('Show Me How')}
          </AppButton>

          <AppButton
            fill={isMobile}
            buttonType="secondary"
            width="180px"
            onClick={handleDismiss}
            disabled={!isDismissButtonAvailable}
          >
            Dismiss
          </AppButton>
        </ButtonResponsiveWrapper>
      </div>
    </Banner>
  );
};

export default ImportantChangesBanner;
